import { colors } from '../theme';
import { dateTime, titleCase } from '../utils/format';

/**
 * The live status timeline shown on every order, booking and ride.
 *
 * `flow` is the ordered list of statuses for that document type; anything up to
 * and including the current status is drawn as done, with the timestamp the
 * server recorded for it.
 */
const StatusTimeline = ({ flow, status, timeline = [] }) => {
  const current = flow.indexOf(status);

  return (
    <div style={{ marginTop: 16 }}>
      {flow.map((step, i) => {
        const done = i <= current;
        const isLast = i === flow.length - 1;
        const at = timeline.find((t) => t.status === step);
        return (
          <div key={step} className="step-row">
            <div className="step-rail">
              <span className={`step-dot ${done ? 'on' : ''}`}>{done ? '✓' : ''}</span>
              {!isLast ? <span className={`step-line ${i < current ? 'on' : ''}`} /> : null}
            </div>
            <div className="grow" style={{ paddingBottom: isLast ? 0 : 18 }}>
              <div
                className="t-body"
                style={{ color: done ? colors.ink : colors.muted, fontWeight: done ? 700 : 500 }}
              >
                {titleCase(step)}
              </div>
              {at ? <div className="t-tiny">{dateTime(at.at)}</div> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatusTimeline;
